<div class="d-flex min-vh-100 position-relative overflow-hidden">
  <!-- Animated Background -->
  <div
    class="bg-gradient position-absolute top-0 start-0 w-100 h-100"
    style="
      background: linear-gradient(
        -45deg,
        #1e3c72 0%,
        #2a5298 25%,
        #667eea 50%,
        #764ba2 75%,
        #f093fb 100%
      );
      background-size: 400% 400%;
      animation: gradientShift 15s ease infinite;
      z-index: -1;
    "
  ></div>

  <!-- Centered Loading Card -->
  <div class="container d-flex justify-content-center align-items-center min-vh-100 w-100">
    <div class="w-100" style="max-width: 420px">
      <div
        class="card border-0 shadow-xl rounded-4 overflow-hidden position-relative"
        style="
          background: rgba(255, 255, 255, 0.98);
          backdrop-filter: blur(20px);
          border: 1px solid rgba(255, 255, 255, 0.2);
          transform: translateY(-8px);
        "
      >
        <div class="card-body p-5 text-center">
          <!-- Animated Background Pattern -->
          <div
            class="position-absolute top-0 start-0 w-100 h-100 opacity-10 pattern-bg"
            style="
              background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxkZWZzPgo8cGF0dGVybiBpZD0iZ3JhaW4iIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiBwYXR0ZXJuVW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPGNpcmNsZSBjeD0iMjUiIGN5PSIyNSIgcj0iMSIgZmlsbD0iIzY2N2VlYSIgb3BhY2l0eT0iMC4zIi8+CjxjaXJjbGUgY3g9Ijc1IiBjeT0iNzUiIHI9IjEuNSIgZmlsbD0iIzc2NGJhMiIgb3BhY2l0eT0iMC4zIi8+CjxjaXJjbGUgY3g9IjUwIiBjeT0iMTAiIHI9IjAuOCIgZmlsbD0iIzFlM2M3MiIgb3BhY2l0eT0iMC40Ii8+CjwvcGF0dGVybj4KPHJlY3Qgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIGZpbGw9InVybCgjZ3JhaW4pIi8+CjwvZGVmcz4KPC9zdmc+');
              pointer-events: none;
              z-index: 0;
            "
          ></div>

          <div class="position-relative z-1">
            <!-- Magic Link Icon Animation -->
            <div class="mb-4">
              <div
                class="loading-magic-icon mx-auto mb-3"
                style="
                  width: 80px;
                  height: 80px;
                  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                  border-radius: 50%;
                  position: relative;
                  animation: pulseGlow 2s ease-in-out infinite;
                  box-shadow: 0 0 30px rgba(102, 126, 234, 0.4);
                "
              >
                <i
                  class="fas fa-magic position-absolute top-50 start-50 translate-middle"
                  style="font-size: 2rem; color: white; text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3)"
                ></i>
                <div
                  class="position-absolute top-50 start-50 translate-middle"
                  style="
                    width: 40px;
                    height: 40px;
                    background: rgba(255, 255, 255, 0.2);
                    border-radius: 50%;
                    animation: floatRing 3s ease-in-out infinite;
                  "
                ></div>
              </div>
              <h2
                class="h3 fw-bold mb-3"
                style="
                  background: linear-gradient(135deg, #1e3c72 0%, #667eea 100%);
                  -webkit-background-clip: text;
                  -webkit-text-fill-color: transparent;
                  background-clip: text;
                  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
                "
              >
                Accesso in corso...
              </h2>
            </div>

            @if(loading) {
            <div class="loading-content">
              <!-- Dual Spinner Animation -->
              <div class="spinner-container mb-4">
                <div
                  class="spinner-border spinner-border-lg text-primary mx-2 mb-3"
                  role="status"
                  style="width: 3rem; height: 3rem; animation: spinnerRotate 1.5s linear infinite"
                >
                  <span class="visually-hidden">Caricamento...</span>
                </div>
                <div
                  class="spinner-grow spinner-grow-lg text-info mx-2 mb-3 pulse-effect"
                  role="status"
                  style="width: 2.5rem; height: 2.5rem"
                >
                  <span class="visually-hidden">Verifica...</span>
                </div>
              </div>

              <div class="progress-wrapper mb-4">
                <div class="progress rounded-4 shadow-sm" style="height: 8px" role="progressbar">
                  <div
                    class="progress-bar progress-bar-animated bg-gradient progress-bar-striped"
                    role="progressbar"
                    style="
                      width: 60%;
                      background: linear-gradient(90deg, #667eea, #764ba2);
                      animation: progressMove 2s ease-in-out infinite;
                    "
                  ></div>
                </div>
                <p class="text-muted small mt-2 mb-0 fw-medium opacity-75">
                  <i class="fas fa-circle-notch fa-spin me-1 opacity-50"></i>
                  Stiamo verificando il tuo Magic Link...
                </p>
              </div>

              <!-- Floating particles -->
              <div class="particles-container">
                <div class="particle particle-1"></div>
                <div class="particle particle-2"></div>
                <div class="particle particle-3"></div>
              </div>
            </div>
            } @if(error) {
            <div
              class="alert alert-danger mt-4 p-4 rounded-3 shadow-sm border-0 position-relative overflow-hidden"
              role="alert"
              style="
                background: rgba(220, 53, 69, 0.1);
                border-left: 5px solid #dc3545;
                backdrop-filter: blur(10px);
                animation: shake 0.5s ease-in-out;
              "
            >
              <div class="d-flex align-items-center">
                <i class="fas fa-exclamation-triangle me-3 text-danger fs-4 opacity-75"></i>
                <div>
                  <h5 class="mb-1 fw-semibold" style="color: #dc3545">Link non valido</h5>
                  {{ error }}
                </div>
              </div>
              <button
                class="btn btn-outline-danger btn-sm position-absolute end-0 top-0 mt-2 me-3 rounded-pill px-3"
                (click)="retry()"
                style="font-size: 0.8rem; border: 2px solid rgba(220, 53, 69, 0.5)"
              >
                <i class="fas fa-redo me-1"></i>Riprova
              </button>
            </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<style>
  @keyframes gradientShift {
    0%,
    100% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
  }

  @keyframes pulseGlow {
    0%,
    100% {
      box-shadow: 0 0 30px rgba(102, 126, 234, 0.4);
      transform: scale(1);
    }
    50% {
      box-shadow: 0 0 50px rgba(102, 126, 234, 0.7);
      transform: scale(1.05);
    }
  }

  @keyframes floatRing {
    0%,
    100% {
      transform: scale(0.8) translateY(0);
      opacity: 0.5;
    }
    50% {
      transform: scale(1.2) translateY(-10px);
      opacity: 0.2;
    }
  }

  @keyframes spinnerRotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes progressMove {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(200%);
    }
  }

  @keyframes shake {
    0%,
    100% {
      transform: translateX(0);
    }
    25% {
      transform: translateX(-5px);
    }
    75% {
      transform: translateX(5px);
    }
  }

  /* Loading content animations */
  .loading-content {
    animation: fadeInUp 0.8s ease-out;
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .pulse-effect {
    animation: pulse 1.5s infinite;
  }

  @keyframes pulse {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.1);
    }
    100% {
      transform: scale(1);
    }
  }

  /* Particles animation */
  .particles-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 1;
  }

  .particle {
    position: absolute;
    width: 4px;
    height: 4px;
    background: rgba(102, 126, 234, 0.6);
    border-radius: 50%;
    animation: floatParticle 6s infinite linear;
  }

  .particle-1 {
    top: 20%;
    left: 10%;
    animation-delay: 0s;
  }
  .particle-2 {
    top: 60%;
    right: 20%;
    animation-delay: 2s;
  }
  .particle-3 {
    bottom: 30%;
    left: 70%;
    animation-delay: 4s;
  }

  @keyframes floatParticle {
    0% {
      transform: translateY(100vh) scale(0);
      opacity: 0;
    }
    10% {
      opacity: 1;
    }
    90% {
      opacity: 1;
    }
    100% {
      transform: translateY(-100vh) scale(1);
      opacity: 0;
    }
  }

  /* Hover effects */
  .card:hover {
    transform: translateY(-12px) !important;
    box-shadow: 0 25px 60px rgba(0, 0, 0, 0.25) !important;
  }

  /* Button hover */
  .btn-outline-danger:hover {
    background: rgba(220, 53, 69, 0.1);
    transform: translateY(-1px);
    box-shadow: 0 5px 15px rgba(220, 53, 69, 0.3);
  }

  /* Responsive */
  @media (max-width: 576px) {
    .card {
      margin: 1rem !important;
      transform: none !important;
    }
    .card-body {
      padding: 2rem 1.5rem !important;
    }
    .loading-magic-icon {
      width: 70px !important;
      height: 70px !important;
    }
  }

  /* Smooth transitions */
  * {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
</style>
